export function getOnKeyHandlerProps(props, ref) {
    var propsToUse = {
        onKeyDown: props.onKeyDown,
        onKeyDownCapture: props.onKeyDownCapture,
        onKeyPress: props.onKeyPress,
        onKeyPressCapture: props.onKeyPressCapture,
        onKeyUp: props.onKeyUp,
        onKeyUpCapture: props.onKeyUpCapture,
    };
    if (props.refOnKeyDown) {
        var propOnKeyDown_1 = props.onKeyDown;
        propsToUse.onKeyDown = function (e) { propOnKeyDown_1 && propOnKeyDown_1(e); props.refOnKeyDown(ref.current, e); };
    }
    if (props.refOnKeyUp) {
        var propOnKeyUp_1 = props.onKeyUp;
        propsToUse.onKeyUp = function (e) { propOnKeyUp_1 && propOnKeyUp_1(e); props.refOnKeyUp(ref.current, e); };
    }
    return {
        classes: {},
        props: propsToUse,
        styles: {},
        variables: {}
    };
}
